import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: { label: string; href: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${centered ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"}`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <span className="mb-3 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium tracking-wide text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px] md:leading-tight">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.href}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {action.label}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}